var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5998 8.80002V7.88574C6.5998 4.84683 9.00838 2.40002 11.9998 2.40002C14.9912 2.40002 17.3998 4.84683 17.3998 7.88574V8.80002M6.5998 8.80002C5.6098 8.80002 4.7998 9.62288 4.7998 10.6286V19.7714C4.7998 20.7772 5.6098 21.6 6.5998 21.6H17.3998C18.3898 21.6 19.1998 20.7772 19.1998 19.7714V10.6286C19.1998 9.62288 18.3898 8.80002 17.3998 8.80002M6.5998 8.80002H17.3998M11.9998 16.2V13.8",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/Lock.1350ab734d987ea86c40ba25ccfee756.svg";
export { ForwardRef as ReactComponent };